import React from "react";
import styles from "./VariantItem.module.scss";
import ImageMock from "../../../../../../../../assets/images/envImageMock.png";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../../redux/store";
import {
  getActiveObjectId,
  getProductByIdAndPath,
  getCurrentCategoryFolder,
  getProductFromCache,
} from "../../../../../../../../redux/reducers/ui/selectors/objectSelectors";
import clsx from "clsx";
import { replaceObjectDataAction } from "../../../../../../../../redux/reducers/ui/actions/actions";
import { UrlService } from "../../../../../../../../services/UrlService";

interface PropsI {
  projectId: number;
  productId: number;
  path: number[];
}
export const VariantItem: React.FC<PropsI> = ({
  productId,
  projectId,
  path,
}) => {
  const dispatch = useAppDispatch();
  const activeObjectId = useAppSelector(getActiveObjectId);
  const currentCategoryFolder = useAppSelector(getCurrentCategoryFolder);
  const productFromPath = useAppSelector(
    getProductByIdAndPath(productId, path, projectId)
  );
  const productFromCache = useAppSelector(
    getProductFromCache(projectId, productId)
  );

  // First try to get product from currentCategoryFolder (has fetched products)
  const projectInFolder = currentCategoryFolder?.projects?.find(
    p => p.id === projectId
  );
  const productFromFolder = projectInFolder?.availableProducts?.find(
    p => p.id === productId
  );

  // Prefer folder, then cache, then path
  const product = productFromFolder || productFromCache || productFromPath;

  const handleClick = () => {
    if (!activeObjectId || !product) return;

    dispatch(
      replaceObjectDataAction({
        prevProductId: activeObjectId,
        product: product,
        projectId: projectId,
      })
    );
  };

  if (!product) return null;

  const realActiveProductId = parseInt(activeObjectId?.split("_")[0] ?? "-1");
  return (
    <div
      className={clsx(styles.item_wrapper, {
        [styles.active]: realActiveProductId === product.id,
      })}
      onClick={handleClick}
    >
      <div className={styles.image_wrapper}>
        <img src={UrlService.getImageServerCdnUrl(product.imgCover)  ?? ImageMock} alt="object img" />
      </div>
      <p className={styles.title}>{product.name}</p>
    </div>
  );
};
